<div class="h-100 position-relative text-grey">
	<div class="modal-header">
		<h4 class="modal-title synchpc-primary" id="modal-title">Create Job Form</h4>
		<i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onClose()" title="Close"></i>
	</div>
	<div class="modal-body" style="height: 75%"> 
		<div style="display: flex; flex-direction: column; height: 100%;">
			<div style="flex-grow: 1; overflow-y: auto;" class="jobFormContent">
				<div *ngIf="fieldsAdded.length == 0" class="mt-5 text-center">
					<p style="letter-spacing: 1px; color: var(--s-border-color); cursor: default;">No fields added yet.</p>
				</div>
				<table class="table table-striped" *ngIf="fieldsAdded.length > 0">
					<thead>
						<!-- <tr class="table-list-head"> -->
							<th width="7%">#</th>
							<th width="40%">Name</th>
							<th width="17%">Required</th>
							<th width="18%">Type</th>
							<th width="18%">Actions</th>
						<!-- </tr> -->
					</thead>
					<tbody>
						<tr class="table-list-row" *ngFor="let data of fieldsAdded; let i = index">
							<td>{{ i + 1 }}</td>
							<td>{{ data.fieldName }}</td>
							<td>{{ data.isFieldRequired == true ? "Required" : "Optional" }}</td>
							<td>{{ data.fieldType }}</td>
							<td>
								<span (click)="onEdit(data)" title="Edit field" class="bi bi-pencil-square pencilIcon"></span>
								<span (click)="onDelete(data)" title="Edit field" class="bi bi-x-lg deleteIcon"></span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="text-center mx-2 mt-2">
				<button style="width: 100%;" class="btn btn-primary" (click)="addNewField()">Add New Field +</button>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-outline-secondary" (click)="onClose()">Close</button>
		<button type="button" class="btn btn-primary" (click)="onSubmit()">
			Submit
		</button>
	</div>
	<ngx-spinner
		bdColor="rgba(0,0,0,0)"
		size="default"
		name="buildform"
		zIndex="1"
		color="var(--s-primary-color)"
		type="ball-spin"
		[fullScreen]="false"
		><p class="pleaseWait" style="margin-top: 1rem!important;">Please wait ...</p></ngx-spinner
	>
</div>